import type React from "react";
import { useState } from "react";

import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { HealthReport } from "api/models/HealthReport";
import { MUICheckBox } from "shared/atoms/inputs";

import { ReportsDropdown } from "../ReportsDropdown";

interface Props {
  reportList: HealthReport[];
  selected: number[];
  changeCallback: (selectedIds: number[]) => void;
  rowsCallback: (hide: boolean) => void;
}

export const HealthReportsHeader: React.FC<Props> = ({ reportList, selected, changeCallback, rowsCallback }) => {
  const { t } = useTranslation();
  const [hideRows, setHideRows] = useState(false);

  const handleCheck = () => {
    if (selected.length >= 2) {
      rowsCallback(!hideRows);
      setHideRows(!hideRows);
    }
  };

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={2} mb={2}>
      <Box sx={{ width: 300, position: "relative", zIndex: 102 }}>
        <ReportsDropdown reportList={reportList} selected={selected} changeCallback={changeCallback} />
      </Box>
      <MUICheckBox
        name="only-changes"
        label={t("patients.health_reports.changed_rows")}
        checked={hideRows}
        disabled={selected.length < 2}
        onChange={() => {
          handleCheck();
        }}
        unregistered
      />
    </Stack>
  );
};
